import React, { Component } from 'react'
import { Button } from 'react-md'
import { FacebookShareButton,
         FacebookIcon,
         TwitterShareButton,
         TwitterIcon,
         GooglePlusShareButton,
         GooglePlusIcon,
         WhatsappShareButton,
         WhatsappIcon } from 'react-share'

import config from '../../../data/SiteConfig'

import './Share.scss'

class Share extends Component {
  static defaultProps = {
    visible: false
  };
  render() {
    const { visible, hide, shareUrl, shareTitle } = this.props
    let Url = `${config.siteUrl}${shareUrl}`
    return (
      <div className="cr-share-box" style={{ right: visible ? '16px' : '-344px' }}>
        <GooglePlusShareButton url={Url}>
          <GooglePlusIcon size={56} round />
        </GooglePlusShareButton>
        <TwitterShareButton url={Url} title={shareTitle}>
           <TwitterIcon size={56} round />
        </TwitterShareButton>
        <WhatsappShareButton url={Url} title={shareTitle} separator=":: ">
          <WhatsappIcon size={56} round />
        </WhatsappShareButton>
        <FacebookShareButton url={Url} quote={shareTitle}>
          <FacebookIcon size={56} round />
        </FacebookShareButton>
      </div>
    )
  }
}

export default Share


// WEBPACK FOOTER //
// ./src/components/Share/Share.js